import types from '../types'
import Action from '../../types/Action'

const initialState = {
  loading: true,
  data: []
}

const mailReducer = (state = initialState, action: Action) => {
  switch (action.type) {
	case types.SEND_MAIL_REQUESTED: {
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
		data: []
      }
    }
    case types.SEND_MAIL_FULFILLED: {
      return {
        ...state,
		loading: false,
        success: true,
        data: action.payload
      }
    }
	case types.SEND_MAIL_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    default:
      return state
  }
}

export default mailReducer